import styled from 'styled-components'

import { type IPunchOutSupplierIconProps } from '../PunchOutSupplierIcon'

interface IPunchOutSupplierIconStyledProps {
  size: IPunchOutSupplierIconProps['size']
}
const INDICATOR_SIZES = {
  xsmall: 13,
  small: 18,
  medium: 24,
  large: 50,
}

export const PunchOutSupplierIconStyled = styled.div<IPunchOutSupplierIconStyledProps>`
  display: inline-block;
  line-height: 1;
  font-size: ${(props) => props.theme.typography.pxToRem(16)};
  vertical-align: middle;
  margin-right: ${(props) => props.theme.space.small};

  img {
    height: ${(props) =>
      props.theme.typography.pxToRem(INDICATOR_SIZES[props.size])};
  }
`
